<script lang="ts">
	import { t } from 'svelte-i18n';
	import { urls } from '@app/urls';
	import List from '$lib/elements/List.svelte';
	import ButtonText from '$lib/elements/buttons/variants/ButtonText.svelte';
	import { page } from '$app/stores';
	import { snackbar } from '$lib/stores';

	export let isTopNav: boolean;
	export let classNames: string;

	$: currentSlug = $page.params.slug;

	let items = [
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.legal.termsOfUse'),
					href: urls.LEGAL.TERMS_OF_USE
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.legal.termsOfUseLW'),
					href: 'https://www.lemonway.com/conditions-generales-dutilisation/'
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.legal.privacyPolicy'),
					href: urls.LEGAL.PRIVACY_POLICY
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.legal.legalNotice'),
					href: urls.LEGAL.LEGAL_NOTICE
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.legal.riskWarning'),
					href: urls.LEGAL.RISK_WARNING
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.legal.claim'),
					href: urls.LEGAL.CLAIM
				}
			}
		}
	];

	if (!isTopNav) {
		let consentItem = {
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.legal.consent')
				}
			},
			listeners: {
				click: () => {
					if (Didomi) {
						Didomi.preferences.show();
					} else {
						snackbar.danger($t('consent.displayNoticeError'));
					}
				}
			}
		};
		items.push(consentItem);
	}

	const setActiveItem = () => {
		items = items.map((i) => {
			if (i.props?.props?.href?.split('/').pop() === currentSlug) {
				i.props.props.classNames = 'active';
			} else {
				i.props.props.classNames = '';
			}
			return i;
		});
	};

	$: currentSlug && setActiveItem();
</script>

<div>
	<!--  TODO : use Tabs component-->
	<List {items} classNames={`${isTopNav ? 'legal-nav-top' : ''} ${classNames}`} listStyle="none" />
</div>

<style lang="postcss">
	div :global(.legal-nav-top a.active) {
		@apply relative;
		&:after {
			content: '';
			@apply absolute w-full h-1 bg-primary bottom-[-10px];
		}
	}
</style>
